<template>
  <div data-app>
    <router-view />
    <meta
      name="viewport"
      content="width=device-width,initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
    />
  </div>
</template>

<style lang="scss">
@import "./assets/styles/App.scss";
</style>

<script>
import { mapState, mapActions } from "vuex";
import PayPal from "@/paypal";

export default {
  components: {},
  computed: {
    ...mapState({
      loaderState: (state) => state.live.loaderState,
      brandName: (state) => state.brandName,
      brandTitle: (state) => state.brandTitle,
      deviceId: (state) => state.client.deviceId,
      conversationId: (state) => state.client.conversationId,
      forbidden: (state) => state.forbidden,
      registering: (state) => state.registering,
      settings: (state) => state.client.settings,
      isHybridPage: (state) => state.client.isHybridPage,
    }),
  },
  methods: {
    ...mapActions("client", [
      "getSettings",
      "setDeviceId",
      "setRegistered",
      "getOwnProfile",
    ]),
    ...mapActions(["setForbidden", "setRegistering"]),
    toggleMenu() {
      this.$store.dispatch("setMenuOpened", !this.$store.getters.isMenuOpened);
    },
  },
  watch: {
    $route() {
      this.$store.dispatch("setMenuOpened", false);
      this.$store.dispatch("addHistory", window.location.pathname);
    },
  },
  created() {
    /**
     * This fragment was moved from beforeCreate() to created()
     * because the variable isHybridPage is undefined in the beforeCreate() method.
     **/
    this.$store.dispatch("addHistory", window.location.pathname);
    PayPal.initialize();
  },
};
</script>
<style>
@font-face {
  font-family: "Avenir-Heavy";
  src: url("./assets/fonts/Avenir/woff/Avenir-Heavy-05.woff") format("woff"),
    url("./assets/fonts/Avenir/ttf/Avenir-Heavy-05.ttf") format("truetype");
}
@font-face {
  font-family: "Avenir";
  src: url("./assets/fonts/Avenir/woff/Avenir-Medium-09.woff") format("woff"),
    url("./assets/fonts/Avenir/ttf/Avenir-Medium-09.ttf") format("truetype");
}
</style>
